function formatWeight(weight) {
  if (weight === null || weight === undefined || weight === '') return null
  const numericValue = Number(weight)
  if (!Number.isFinite(numericValue)) return String(weight)
  return `${Math.round(numericValue * 100)}%`
}

export default function DeadlineEvidenceCard({ evidence = [] }) {
  return (
    <section className="rules-card deadline-result-section">
      <div className="rules-card-header">
        <div>
          <h3>Evidências encontradas</h3>
          <p>Trechos, termos e fontes detectados no texto da publicação/intimação.</p>
        </div>
      </div>
      <div className="rules-card-body">
        {evidence.length ? (
          <div className="deadline-evidence-list">
            {evidence.map((item, index) => (
              <article className="deadline-evidence-item" key={`${item.description || item.type || 'evidence'}-${index}`}>
                <div className="deadline-evidence-header">
                  <strong>{item.type || 'Evidência'}</strong>
                  {formatWeight(item.weight) ? <span>{formatWeight(item.weight)}</span> : null}
                </div>
                <p>{item.message || item.description || 'Descrição não informada.'}</p>
                {(item.fragment || item.matchedText) ? <blockquote>{item.fragment || item.matchedText}</blockquote> : null}
                {item.source ? <small>Fonte: {item.source}</small> : null}
              </article>
            ))}
          </div>
        ) : (
          <p>Nenhuma evidência estruturada retornada.</p>
        )}
      </div>
    </section>
  )
}
